<template>
    <div class="image-progress-child-table">
        <div class="child-one">
            <el-table
                :data="tableData"
                border
                show-summary
            >
                <el-table-column
                    prop="name"
                    label="形象进度"
                >
                </el-table-column>
                <el-table-column
                    prop="dtsl"
                    label="单体数量(个)"
                >
                </el-table-column>
                <el-table-column
                    prop="yjfl"
                    label="预计方量(方)"
                >
                </el-table-column>
                <el-table-column
                    prop="yyfl"
                    label="已用方量(方)"
                >
                </el-table-column>
                <el-table-column
                    prop="ddsl"
                    label="订单数(个)"
                >
                </el-table-column>
                <el-table-column
                    prop="fhdsl"
                    label="发货单数量(个)"
                >
                </el-table-column>
            </el-table>
        </div>
        <div class="child-two">
            <h1>方量对比</h1>
            <div style="width:100%;height:360px" id="volumeComparisonChildId"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tableData: [],
            echartsName: [],
            echartsYjfl: [],
            echartsYyfl: [],
            // selectTimeData: ['2020-01-01', '2020-06-20'],
        };
    },
    props: {
        selectTimeData: {
            type: Array,
        },
    },
    mounted() {
        this.salesanalysisAqy();
    },
    methods: {
        volumeComparisonFun() {
            const myChart = this.$echarts.init(document.getElementById('volumeComparisonChildId'));
            const optionVo = {
                grid: {
                    top: '13%',
                    left: '0%',
                    right: '9%',
                    bottom: '3%',
                    containLabel: true,
                },
                legend: {
                    itemWidth: 8,
                    itemHeight: 8,
                    data: ['已用方量', '预计方量'],
                    x: 'right',
                    padding: [20, 50, 0, 0],
                },
                xAxis: {
                    data: this.echartsName,
                    type: 'category',
                    axisLabel: {
                        color: '#666666',
                        fontSize: 10,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    splitLine: { show: false },
                },
                yAxis: {
                    name: '单位(方)',
                    nameTextStyle: {
                        padding: [0, 0, -20, 50], // 四个数字分别为上右下左与原位置距离
                        color: '#979EA7',
                        fontSize: '10',
                    },
                    axisLabel: {
                        color: '#666666',
                        fontSize: 10,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D7D7D7',
                        },
                    },
                    splitLine: { show: false },
                },
                series: [
                    {
                        name: '已用方量',
                        data: this.echartsYyfl,
                        type: 'bar',
                        barWidth: 15,
                        color: '#44A1F5',
                        label: {
                            show: true,
                            position: 'top',
                            fontFamily: 'QuartzLTStd',
                        },
                    },
                    {
                        name: '预计方量',
                        data: this.echartsYjfl,
                        type: 'bar',
                        barWidth: 15,
                        color: '#F0AF56',
                        label: {
                            show: true,
                            position: 'top',
                            fontFamily: 'QuartzLTStd',
                        },
                    },
                ],
            };
            myChart.setOption(optionVo, true);
        },
        // 按施工部位
        salesanalysisAqy() {
            this.$axios
                .get(`/interfaceApi/report/salesanalysis/gcyl/dtjd?startDate=${this.selectTimeData[0]}&endDate=${this.selectTimeData[1]}`)
                .then(res => {
                    this.tableData = res.list;
                    this.tableData.forEach(item => {
                        this.echartsName.push(item.name);
                        this.echartsYjfl.push(item.yjfl);
                        this.echartsYyfl.push(item.yyfl);
                    });
                    this.volumeComparisonFun();
                })
                .catch(err => {
                    console.log(err);
                });
        },
    },
};

</script>
<style lang='stylus'>
.image-progress-child-table
    padding 0 20px 20px 20px
    display flex
    .child-one
        flex 1
        .el-table
            thead tr th
                background #EDF0F5
                color #022782
                font-weight 800
            td, th
                width 100px
                padding 0
                text-align center
                font-size 16px
                div
                    height 40px
                    line-height 40px
        .el-table__footer tr td
            background none
            color #C9661E
            &:first-child
                background #F5F2ED
                color #823802
    .child-two
        flex 1
        margin-left 20px
        border 1px solid #D7D7D7
        padding 20px
        h1
            color #333333
            font-size 18px
            font-weight 800
            &:before
                content '`'
                width 6px
                height 20px
                background #4D7DE0
                color #4D7DE0
                margin-right 10px
</style>